// Context
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import apiAdmin from "../../services/apiAdmin";
import moment from "moment";
import { onPressEnter } from "../../utils/utils";
import { useAuth } from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";

function ModalTicketDetail({ ticket, setSelectedTicket }) {
  const { t } = useTranslation();
  const { setHasNotifications } = useAuth();

  useEffect(() => {
    if (ticket.toRead) {
      setHasNotifications(false);
    }
    apiAdmin
      .getTicket(ticket.id)
      .then((res) => {
        setSelectedTicket(res.data);
      })
      .catch((e) => {
        // The admin interceptor throws on every non-2xx; unhandled, the modal
        // silently kept the list's copy of the ticket (no messages) and nobody
        // was told the refresh failed. Message only -- never the raw axios error.
        console.error("Ticket load failed -", e?.message || e);
        toast.error(t("tickets.list.errorFetching"));
      });
    // eslint-disable-next-line
  }, []);

  const [message, setMessage] = useState();

  const sendMessage = async () => {
    let req;
    try {
      req = await apiAdmin.sendMessage(ticket.id, message);
    } catch (e) {
      // Same shape as ModalTicketCreate: the interceptor throws on non-2xx, so
      // the else branch below is never the failure path. Message only -- the
      // raw axios error carries the typed message in config.data.
      console.error("Ticket message send failed -", e?.message || e);
      toast.error(t("tickets.detail.errorSending"));
      return;
    }
    if (req.status === 200) {
      if (!ticket.messages) ticket.messages = [];
      ticket.messages.push(req.data);
      setSelectedTicket({ ...ticket });
      setMessage("");
      toast.success(t("tickets.detail.messageSent"));
      setTimeout(() => {
        if (window.document.querySelector(".ticket-modal .modal-content")) {
          window.document.querySelector(".ticket-modal .modal-content").scrollTop =
            window.document.querySelector(".ticket-modal .modal-content").scrollHeight;
        }
      }, 100);
    } else {
      toast.error(t("tickets.detail.errorSending"));
    }
  };

  return (
    <>
      <div className="ticket-view">
        <div className="ticket-content-header">
          <div className="ticket-title">{t("tickets.detail.ticketCode", { code: ticket.code })}</div>
          <div
            className={
              "mr-0 badge " +
              (ticket.status === "Created" ? "blue" : "") +
              (ticket.status === "In Progress" ? "light-blue" : "") +
              (ticket.status === "Closed" ? "green" : "") +
              (ticket.status === "Invalid" ? "red" : "")
            }
          >
            {ticket.status}
          </div>
        </div>

        <div className="row-form">
          <label>{t("tickets.detail.issueType")}</label>
          <div>{ticket.type || t("tickets.detail.newIssue")}</div>
        </div>
        <div className="row-form">
          <label>{t("tickets.detail.created")}</label>
          <div>{moment(ticket.date).fromNow()}</div>
        </div>
        <div className="row-form">
          <label>{t("tickets.detail.estResolutionTime")}</label>
          <div>{moment(ticket.resolutionDate).fromNow()}</div>
        </div>

        <div className="progress-bar-wrapper">
          <h4>{t("tickets.detail.resolutionProgress")}</h4>
          <div className="ticket-bar">
            <div
              className="ticket-bar-progress"
              style={{ width: ticket.status === "In Progress" ? "66%" : ticket.status === "Closed" ? "100%" : "33%" }}
            ></div>
          </div>
        </div>

        <h4 className="message-title">{t("tickets.detail.messages")}</h4>
        <div className="ticket-messages">
          <div className="message USER">{ticket.description}</div>
          {ticket.messages?.map((message) => (
            <div key={message.id} className={"message " + message.source}>
              {message.message}
            </div>
          ))}
        </div>
        <div className="modal-actions">
          <input
            type="text"
            placeholder={t("tickets.detail.typeMessage")}
            className="ml-10"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={onPressEnter(sendMessage)}
          />
          <button className="btn btn-round mr-10" onClick={sendMessage}>
            <i className="notranslate material-icons">send</i>
          </button>
        </div>
      </div>
    </>
  );
}

export default ModalTicketDetail;
